module.exports = __webpack_public_path__ + "01f43047/img/file-icon.c085e21e.svg";